var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13333 9.33333H17.8667C18.4533 9.33333 18.9333 9.80266 18.9333 10.4V13.6C18.9333 14.1867 18.4533 14.6667 17.8667 14.6667H6.13333C5.536 14.6667 5.06667 14.1867 5.06667 13.6V10.4C5.06667 9.80266 5.536 9.33333 6.13333 9.33333ZM4 10.4C4 9.216 4.94933 8.26666 6.13333 8.26666H17.8667C19.04 8.26666 20 9.216 20 10.4V13.6C20 14.7733 19.04 15.7333 17.8667 15.7333H6.13333C4.94933 15.7333 4 14.7733 4 13.6V10.4ZM8.8 11.2C8.352 11.2 8 11.552 8 12C8 12.4373 8.352 12.8 8.8 12.8C9.23733 12.8 9.6 12.4373 9.6 12C9.6 11.552 9.23733 11.2 8.8 11.2ZM11.2 12C11.2 11.552 11.552 11.2 12 11.2C12.4373 11.2 12.8 11.552 12.8 12C12.8 12.4373 12.4373 12.8 12 12.8C11.552 12.8 11.2 12.4373 11.2 12ZM15.2 11.2C14.752 11.2 14.4 11.552 14.4 12C14.4 12.4373 14.752 12.8 15.2 12.8C15.6373 12.8 16 12.4373 16 12C16 11.552 15.6373 11.2 15.2 11.2Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/button-icon.8ace229269d8798f9c29465f5ac43087.svg";
export { ForwardRef as ReactComponent };